class XhrPromise extends Promise {
  constructor(fn, req) {
    super(fn);
    this.xhr = req;
  }
}
export default XhrPromise;